import styled from "styled-components";
import { SettingsLabel } from "../controls/SettingsLabel";
import { Flex, Switch, SwitchProps } from "antd";

type PanelSectionProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  primary?: boolean;
  noPadding?: boolean;
  noBorder?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  switchProps?: SwitchProps;
};

export const PanelSection = ({
  title,
  subtitle,
  primary = false,
  noPadding,
  noBorder,
  children,
  style,
  switchProps,
}: PanelSectionProps) => {
  return (
    <StyledSection $noPadding={noPadding} $noBorder={noBorder} style={style}>
      <Flex vertical style={{ maxWidth: "100%" }}>
        {title && (
          <>
            <Flex align="center" gap={8} justify="space-between">
              <SettingsLabel
                style={{ flexShrink: 0 }}
                {...(primary ? {} : { type: "secondary" })}
              >
                {title}
              </SettingsLabel>
              {switchProps && <Switch size="small" {...switchProps} />}
            </Flex>
            {noBorder && !primary && <StyledDivider />}
          </>
        )}
        {subtitle && <SettingsLabel type="secondary">{subtitle}</SettingsLabel>}
      </Flex>
      {children}
    </StyledSection>
  );
};

const StyledDivider = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colorBorder};
  margin: 0;
`;

const StyledSection = styled.section<{
  $noPadding?: boolean;
  $noBorder?: boolean;
}>`
  border-bottom: ${({ $noBorder, theme }) =>
    $noBorder ? "none" : `1px solid ${theme.colorBorder}`};
  padding: 12px;
  position: relative;
  padding-inline: ${({ $noPadding }) => ($noPadding ? 0 : 12)}px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  max-width: 100%;
`;
